import React from 'react';

import {ModalPopup} from '@kit';

import {GlossaryDescription} from './expandable-row';

import css from './sheet.module.css';

type Props = {
	/** идентификатор статьи глоссария */
	id: string;
	header: string;
	onClose(): void;
};

/** окно со статьёй глоссария */
export const GlossaryModal: React.FC<Props> = ({id, header, onClose}) => (
	<ModalPopup open onClose={onClose} header={header} maxWidth={560}>
		<GlossaryDescription id={id} className={css.restArticle} />
	</ModalPopup>
);
